import { memo, useCallback, useState } from 'react';

import { useAppSelector } from '@/store/hooks';
import useLoadCategories from '@/connection/hooks/use-load-categories';
import { getCategories } from '@/store/slices/categories/selectors';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import CustomSelect from '@ui/select/custom-select/custom-select';

type CoursesCategoriesSelectProps = {
  defaultCategories?: TReactSelectOption[];
  onMenuClose: (selectedCategories: TReactSelectOption[]) => void;
  disabled?: boolean;
};

const CoursesCategoriesSelect = memo(({ disabled, defaultCategories, onMenuClose }: CoursesCategoriesSelectProps) => {
  useLoadCategories({ skipIfCategoriesExist: true });

  const channelCategories = useAppSelector(getCategories);

  const [selectedOptions, setSelectedOptions] = useState<TReactSelectOption[]>(defaultCategories ?? []);

  const handleAddNew = useCallback((inputValue: string) => {
    setSelectedOptions((current) => [...current, { label: inputValue, value: inputValue }]);
  }, []);

  const handleFocusClosed = useCallback(
    (selected: TReactSelectOption[]) => {
      onMenuClose(selected);
    },
    [onMenuClose]
  );

  return (
    <CustomSelect
      id="courses-categories-select"
      hideHeader
      labelHeight="32px"
      Placeholder="Add categories"
      options={(channelCategories || []).map((c) => ({
        label: c.toString(),
        value: c.toString(),
      }))}
      controlledOptions={selectedOptions}
      onChange={setSelectedOptions}
      disabled={disabled}
      isMultiSelect
      filterSelected
      inputPadding="0px 14px"
      clearInputOnMouseSelect
      onAddNewSelect={handleAddNew}
      onFocusClosed={handleFocusClosed}
    />
  );
});

export default CoursesCategoriesSelect;
